var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm.loading
      ? _c(
          "div",
          { staticClass: "sidebar-loading" },
          [_c("w-progress-circular", { attrs: { small: "" } })],
          1
        )
      : _vm.stock
      ? _c(
          "div",
          { staticClass: "sidebar-table-wrap" },
          [
            _c(
              "app-custom-table",
              {
                staticClass: "sidebar-table",
                attrs: { cellpadding: "0", cellspacing: "0" },
              },
              [
                _c("thead", [
                  _c("tr", [
                    _c("th", [
                      _vm._v(_vm._s(_vm.$ct("sidebar.product-stock.location"))),
                    ]),
                    _c("th", { staticClass: "amount" }, [
                      _vm._v(_vm._s(_vm.$ct("sidebar.product-stock.amount"))),
                    ]),
                  ]),
                ]),
                _c(
                  "tbody",
                  _vm._l(_vm.locations, function (loc) {
                    return _c("tr", { key: loc.id }, [
                      _c("td", [_vm._v(_vm._s(loc.name))]),
                      _c("td", { staticClass: "amount" }, [
                        _vm._v(_vm._s(loc.qty)),
                      ]),
                    ])
                  }),
                  0
                ),
                _c("tfoot", [
                  _c("tr", [
                    _c("td", [
                      _c("b", [
                        _vm._v(_vm._s(_vm.$ct("sidebar.product-stock.total"))),
                      ]),
                    ]),
                    _c("td", { staticClass: "amount" }, [
                      _c("b", [_vm._v(_vm._s(_vm.total))]),
                    ]),
                  ]),
                ]),
              ]
            ),
          ],
          1
        )
      : _c("div", { staticClass: "sidebar-empty" }, [
          _vm._v(_vm._s(_vm.$ct("sidebar.product-stock.no-stock"))),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }